// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1TfRJ","title":"InfoRow_title__3HpUl"};